module.exports = __webpack_public_path__ + "static/img/registerBg2.fd50a4ee.png";